import { render, staticRenderFns } from "./ConfirmOrderDialog.vue?vue&type=template&id=22182278"
import script from "./ConfirmOrderDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmOrderDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports